import '../styles/GlobalDesign.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import WhatsAppButton from '../components/WhatsAppButton';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

const Home = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [heroContent, setHeroContent] = useState(null);

  useEffect(() => {
    loadHomeContent();
  }, []);

  const loadHomeContent = async () => {
    try {
      const heroRes = await axios.get(`${API_URL}/admin/home-manager/hero`);
      setHeroContent(heroRes.data.hero || null);
    } catch (error) {
      console.error('Erreur chargement contenu:', error);
    }
  };

  return (
    <div className="home-container home-page public-page">
      {/* Menu hamburger pour mobile - EN DEHORS du navbar */}
      <button className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </button>

      {/* Navbar - Nouveau Design */}
      <nav className="new-design-navbar">
        <div className="new-design-container">
          <a href="/" className="new-design-logo">
            <img src="/logo.png" alt="Fluxivo" className="new-design-logo-img" style={{height: '36px', width: 'auto'}} />
            <span className="new-design-logo-text">Flux<span>ivo</span></span>
          </a>
          
          <ul className={`new-design-nav-links ${mobileMenuOpen ? 'mobile-open' : ''}`}>
            <li><a href="#accueil" onClick={() => setMobileMenuOpen(false)}>Accueil</a></li>
            <li><a href="/plans" onClick={() => setMobileMenuOpen(false)}>Tarifs</a></li>
            <li><a href="#avantages" onClick={() => setMobileMenuOpen(false)}>Avantages</a></li>
            <li><a href="#temoignages" onClick={() => setMobileMenuOpen(false)}>Témoignages</a></li>
            <li><a href="/reseller/login" onClick={() => setMobileMenuOpen(false)}>Revendeur</a></li>
          </ul>
          
          <a href="/reseller/login" className="new-design-btn-login">Devenir Revendeur</a>
        </div>
      </nav>

      {/* Overlay pour fermer le menu mobile */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
          <nav className="mobile-nav-links" onClick={(e) => e.stopPropagation()}>
            <a href="#accueil" onClick={() => setMobileMenuOpen(false)}>🏠 Accueil</a>
            <a href="/plans" onClick={() => setMobileMenuOpen(false)}>💳 Tarifs</a>
            <a href="#avantages" onClick={() => setMobileMenuOpen(false)}>⭐ Avantages</a>
            <a href="#temoignages" onClick={() => setMobileMenuOpen(false)}>💬 Témoignages</a>
            <a href="/reseller/login" onClick={() => setMobileMenuOpen(false)}>🤝 Revendeur</a>
          </nav>
        </div>
      )}

      {/* Hero Banner Section - Nouveau Design */}
      <section 
        className="new-design-hero" 
        id="accueil"
        style={{
          background: `linear-gradient(rgba(10, 10, 20, 0.7), rgba(10, 10, 20, 0.85)), url(${process.env.PUBLIC_URL}/Fond/iptv%20image.jpg)`
        }}
      >
        <div className="new-design-hero-content">
          <h1 className="new-design-hero-title">
            {heroContent?.title || 'Streaming Premium'}
            <br />
            <span className="new-design-highlight">Sans Limites</span>
          </h1>
          <p className="new-design-hero-subtitle">
            {heroContent?.subtitle || 'Accédez à des milliers de chaînes TV, films et séries en qualité 4K. L\'expérience de streaming la plus élégante et fluide du marché.'}
          </p>
          <div className="new-design-hero-buttons">
            <a href="https://wa.me/message/SIWSZEADK2LLL1" className="new-design-btn new-design-btn-primary" target="_blank" rel="noreferrer">
              Essai Gratuit 24h
            </a>
            <a href="/plans" className="new-design-btn new-design-btn-secondary">
              S'abonner
            </a>
          </div>
          <div className="new-design-hero-stats">
            <div className="new-design-stat">
              <h3>20000+</h3>
              <p>Chaînes TV</p>
            </div>
            <div className="new-design-stat">
              <h3>4K UHD</h3>
              <p>Qualité Vidéo</p>
            </div>
            <div className="new-design-stat">
              <h3>24/7</h3>
              <p>Support Client</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Banners Section - Nouveau Design */}
      <div className="new-design-cta-banners">
        <div 
          className="new-design-cta-banner new-design-cta-abonnement"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/Fond/Foot01.jpg)` }}
        >
          <div className="new-design-cta-overlay"></div>
          <div className="new-design-cta-banner-content">
            <h2>Vivez le Sport en Direct</h2>
            <p>Accédez à tous les matchs, compétitions et événements sportifs en qualité HD. Football, Basketball, Tennis et plus encore !</p>
            <a href="/plans" className="new-design-btn new-design-btn-primary new-design-btn-large">Voir nos Abonnements</a>
          </div>
        </div>

        <div 
          className="new-design-cta-banner new-design-cta-revendeur"
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/Fond/media01.jpg)` }}
        >
          <div className="new-design-cta-overlay"></div>
          <div className="new-design-cta-banner-content">
            <h2>Devenez Partenaire Revendeur</h2>
            <p>Gagnez jusqu'à 30% de commission sur chaque vente. Inscription gratuite, aucun frais cachés !</p>
            <a href="/reseller/login" className="new-design-btn new-design-btn-primary new-design-btn-large">Devenir Revendeur</a>
          </div>
        </div>
      </div>

      {/* Avantages Section - Nouveau Design */}
      <section className="new-design-features" id="avantages">
        <div className="new-design-container">
          <div className="new-design-section-header">
            <h2>Pourquoi Choisir Fluxivo?</h2>
            <p>Une expérience de streaming incomparable avec des fonctionnalités premium</p>
          </div>
          
          <div className="new-design-features-grid">
            <div className="new-design-feature-item">
              <div className="new-design-feature-number">01</div>
              <h3>Qualité 4K Ultra HD</h3>
              <p>Profitez de la meilleure qualité vidéo disponible avec technologie adaptive bitrate</p>
              <img src="/images/icon-video.svg" alt="Vidéo" className="new-design-feature-icon-img" />
            </div>
            <div className="new-design-feature-item">
              <div className="new-design-feature-number">02</div>
              <h3>+20,000 Chaînes</h3>
              <p>Accédez à toutes les chaînes du monde entier : Sport, Films, Séries, Documentaires</p>
              <img src="/images/icon-tv.svg" alt="TV" className="new-design-feature-icon-img" />
            </div>
            <div className="new-design-feature-item">
              <div className="new-design-feature-number">03</div>
              <h3>Tous Vos Appareils</h3>
              <p>Compatible avec Smart TV, Android, iOS, PC, tablettes et bien plus encore</p>
              <img src="/images/icon-devices.svg" alt="Appareils" className="new-design-feature-icon-img" />
            </div>
            <div className="new-design-feature-item">
              <div className="new-design-feature-number">04</div>
              <h3>Support 24/7</h3>
              <p>Assistance instantanée en français par chat, email ou téléphone 24 heures sur 24</p>
              <img src="/images/icon-support.svg" alt="Support" className="new-design-feature-icon-img" />
            </div>
            <div className="new-design-feature-item">
              <div className="new-design-feature-number">05</div>
              <h3>Pas de Publicités</h3>
              <p>Expérience de visionnage immaculée sans interruptions publicitaires</p>
              <img src="/images/icon-noad.svg" alt="Sans pub" className="new-design-feature-icon-img" />
            </div>
            <div className="new-design-feature-item">
              <div className="new-design-feature-number">06</div>
              <h3>VOD Illimitée</h3>
              <p>Des milliers de films et séries disponibles en streaming à la demande</p>
              <img src="/images/icon-cinema.svg" alt="Cinéma" className="new-design-feature-icon-img" />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section - Nouveau Design */}
      <section className="new-design-pricing bg-green-tint" id="temoignages">
        <div className="new-design-container">
          <div className="new-design-section-header">
            <h2>Témoignages Clients</h2>
            <p>Ce que nos utilisateurs pensent de Fluxivo</p>
          </div>
          
          <div className="new-design-pricing-cards" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))' }}>
            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="text">
                "Service excellent ! J'ai reçu mon lien M3U instantanément. Qualité HD impeccable sur toutes les chaînes. Vraiment premium!"
              </p>
              <div className="author">
                <div className="avatar">MD</div>
                <div>
                  <h4 className="author-name">Mamadou D.</h4>
                  <p className="author-since">Utilisateur depuis 1 an</p>
                </div>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="text">
                "Le support client est impressionnant. Chaque question reçoit une réponse rapide et professionnelle. Interface très élégante!"
              </p>
              <div className="author">
                <div className="avatar">FS</div>
                <div>
                  <h4 className="author-name">Fatou S.</h4>
                  <p className="author-since">Utilisatrice depuis 6 mois</p>
                </div>
              </div>
            </div>

            <div className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="text">
                "Plus de 20,000 chaînes comme promis. Je regarde sur 4 appareils sans problème. Vraiment excellent pour le prix!"
              </p>
              <div className="author">
                <div className="avatar">IN</div>
                <div>
                  <h4 className="author-name">Ibrahima N.</h4>
                  <p className="author-since">Utilisateur depuis 8 mois</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer - Nouveau Design */}
      <footer className="new-design-footer">
        <div className="new-design-container">
          <div className="new-design-footer-grid">
            <div className="new-design-footer-section">
              <h3>Fluxivo</h3>
              <p>La plateforme IPTV la plus élégante et premium du marché.</p>
            </div>

            <div className="new-design-footer-section">
              <h4>Navigation</h4>
              <ul>
                <li><a href="#accueil">Accueil</a></li>
                <li><a href="/plans">Tarifs</a></li>
                <li><a href="#avantages">Avantages</a></li>
                <li><a href="#temoignages">Témoignages</a></li>
              </ul>
            </div>

            <div className="new-design-footer-section">
              <h4>Légal</h4>
              <ul>
                <li><a href="/privacy">Politique de Confidentialité</a></li>
                <li><a href="/how-it-works">Comment ça marche</a></li>
                <li><span>Conditions d'Utilisation</span></li>
              </ul>
            </div>

            <div className="new-design-footer-section">
              <h4>Contact</h4>
              <ul>
                <li><a href="mailto:support@fluxivo.com">support@fluxivo.com</a></li>
                <li><a href="https://wa.me/message/SIWSZEADK2LLL1" target="_blank" rel="noreferrer">WhatsApp</a></li>
                <li>Lun-Dim 00:00-24:00</li>
              </ul>
            </div>
          </div>

          <div className="new-design-footer-bottom">
            <p>&copy; 2026 Fluxivo. Tous droits réservés. | Design Premium Élégant</p>
          </div>
        </div>
      </footer>

      {/* Bouton WhatsApp flottant */}
      <WhatsAppButton />
    </div>
  );
};

export default Home;
